<template>
  <div class="product-details" style="width: 100%">
    <div v-if="product">
      <v-container style="max-width: 1170px">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" md="5" sm="12">
            <!-- <div v-if="product.discounts.length" style="text-align-last: right">
              <v-chip v-for="(discount, i) in product.discounts" style="color: white" color="#ea412a" large :key="i"
                class="product-discount-tag" label>
                <span> {{ getCampaignDiscount(discount) }} % </span>
              </v-chip>
            </div>
            <div v-if="product.bestCampaign && product.bestCampaign.PromotionType == 4
              " style="text-align-last: right">
              <v-chip style="color: white" color="#ea412a" class="product-discount-tag" label>
                <span v-if="product.bestCampaign.BenefitRule == 1">{{ product.bestCampaign.BenefitQty }} for
                  {{ product.bestCampaign.BenefitValue1 }}</span>
                <span v-if="product.bestCampaign.BenefitRule == 2">{{ product.bestCampaign.BenefitQty }} for kr
                  {{ product.bestCampaign.BenefitValue1 | currency() }}</span>
              </v-chip>
            </div> -->
            <div>
              <v-img
                :src="product.imgUrl"
                class="mx-auto hover-hand"
                lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="
                transition="fade-transition"
                width="570"
                height="570"
                @click="productImageDialog = true"
              />
              <div v-if="product.videoUrl" class="text-center">
                <v-icon
                  color="primary"
                  size="40"
                  style="cursor: pointer"
                  @click="galleryPreviewDialog = true"
                >
                  ondemand_video
                </v-icon>
              </div>
            </div>
          </v-col>
          <v-col class="pa-2" cols="12" md="7" sm="12">
            <div class="brands_series__title">
              <div class="font-weight-medium" style="font-size: 30px">
                <router-link
                  :to="{
                    name: 'webshopChainProductsCategories',
                    query: { brand: product.brandId.Base64Guid },
                  }"
                  class="font-weight-regular"
                  >{{ product.brandName }}
                </router-link>
              </div>
              <div class="font-weight-medium" style="font-size: 30px">
                <router-link
                  :to="{
                    name: 'webshopChainProductsCategories',
                    query: { serie: product.seriesId.Base64Guid },
                  }"
                  class="font-weight-regular"
                  >{{ product.serieName }}
                </router-link>
              </div>
            </div>
            <div class="font-weight-bold mt-3" style="font-size: 20px">
              {{ product.title }}
              <v-icon
                v-if="$user.onlineSluttKundeId"
                @click="addAsFavorite()"
                color="primary"
                >{{ `fxt-heart${isUserFavorite ? "-filled" : ""}` }}</v-icon
              >
            </div>

            <div v-if="getCategoryName(product.categoryId)" class="">
              <span>Kategori: </span>
              <a
                @click="goToCategory(getCategoryFirst(product.categoryId))"
                class="font-weight-regular"
                >{{ getCategoryName(product.categoryId) }}
              </a>
            </div>
            <div :class="$vuetify.breakpoint.mdAndUp ? '' : 'd-flex align-end'">
              <div class="d-flex flex-column pt-5 pr-3">
                <div>
                  <span class="font-weight-regular">kr </span>
                  <span
                    class="font-weight-bold"
                    :style="{
                      'font-size':
                        getBestDiscount(product.discounts) != -1
                          ? '18px'
                          : '20px',
                      'text-decoration':
                        getBestDiscount(product.discounts) != -1
                          ? 'line-through'
                          : '',
                    }"
                  >
                    {{ product.productDetails.price | currency(2, 2) }}
                  </span>
                  <span
                    v-if="
                      product.lowestPrice != null && product.discounts.length
                    "
                  >
                    Pris {{ lowestPriceDate() }}:
                    {{ product.lowestPrice | currency(2, 2) }} ({{
                      lowestPriceDiscount()
                    }}%)</span
                  >
                </div>
                <div
                  v-if="getBestDiscount(product.discounts) != -1"
                  :style="{
                    color:
                      getBestDiscount(product.discounts) != -1 ? 'red' : '',
                  }"
                  class=""
                >
                  <span class="font-weight-regular">kr</span>
                  <span class="font-weight-bold" style="font-size: 25px">{{
                    getBestDiscount(product.discounts) | currency(2, 2)
                  }}</span>
                </div>
              </div>
              <add-to-cart-click-and-collect
                class="product__details__btn pb-2"
                :product="product"
                :details="true"
              ></add-to-cart-click-and-collect>
            </div>

            <i>
              <small>
                Endelig pris for dette produktet vil bli presentert i
                handlekurven. Den beste prisen vil bli valgt basert på de
                produktene du skal kjøpe.
              </small>
            </i>
            <div
              class="mt-5 primary--text d-flex flex-row"
              style="align-items: start"
            >
              <v-icon color="primary" class="pr-2">fxt-salon</v-icon>
              <div class="d-flex flex-column">
                <span id="opener"
                  ><b>Hent på stedet:</b> På lager {{ salonsWithStock.length }}
                  {{ salonsWithStock.length === 1 ? " sted" : " steder" }}</span
                >
                <v-menu attach="#opener">
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      color="primary"
                      class="primary--text"
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      outlined
                      small
                      style="max-width: 130px"
                    >
                      Vis steder
                      <v-icon>{{
                        attrs["aria-expanded"] == "true"
                          ? "fxt-chevron-up"
                          : "fxt-chevron-down"
                      }}</v-icon>
                    </v-btn>
                  </template>
                  <v-list disabled>
                    <v-list-item
                      v-for="item in salonSorted"
                      :key="item.siteId"
                      link
                      ripple="false"
                    >
                      <div
                        class="d-flex flex-row justify-space-between"
                        style="width: 100%"
                      >
                        <span class="pr-5">
                          {{ item.siteName }}
                        </span>
                        <div class="d-flex">
                          <span
                            :style="{
                              color: getStockAmountForSite(item)
                                ? 'green'
                                : 'red',
                            }"
                          >
                            {{
                              getStockAmountForSite(item)
                                ? "På lager"
                                : "Utsolgt"
                            }}
                          </span>
                          <v-icon
                            :color="
                              getStockAmountForSite(item) ? 'green' : 'red'
                            "
                          >
                            {{
                              getStockAmountForSite(item)
                                ? "fxt-check"
                                : "fxt-close"
                            }}
                          </v-icon>
                        </div>
                      </div>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div
              class="mt-5 primary--text d-flex flex-row"
              style="align-items: start"
              v-if="!noSalonHasHomeShipment"
            >
              <v-icon color="primary" class="pr-2">fxt-truck</v-icon>
              <div class="d-flex flex-column">
                <span
                  ><b>For hjemsending:</b>
                  {{
                    product.stockForDelivery > 0 ? "På lager" : "Ikke på lager"
                  }}</span
                >
              </div>
            </div>
            <div v-if="!noSalonHasHomeShipment" class="pt-5">
              <img
                class="pr-5"
                v-for="p in activePaymentMethods"
                :key="p"
                :src="p"
              />
            </div>
            <div class="mt-6">
              <v-tabs>
                <v-tab
                  disabled
                  class="font-weight-bold"
                  style="border-bottom: 2px solid var(--v-primary-base)"
                  ><span style="font-size: 20px; color: black"
                    >Beskrivelse</span
                  ></v-tab
                >
              </v-tabs>
              <v-divider style="height: 10px !important" />
              <div class="pt-2" v-html="product.description"></div>
            </div>
            <div
              class="mt-5"
              v-if="
                !$wait.is('load webshop coPurchase') &&
                coPurcahses &&
                coPurcahses.length
              "
            >
              <span
                style="font-size: 20px; color: black"
                class="font-weight-bold"
                >Ofte kjøpt sammen med</span
              >
              <v-divider style="height: 10px !important" />
              <div
                style="width: 100%; text-align: center"
                v-if="$wait.is('load webshop coPurchase')"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </div>
              <div class="d-flex justify-space-between">
                <div class="d-flex">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img :src="product.imgUrl" v-on="on" max-width="80" />
                    </template>
                    <span>{{ product.title }}</span>
                  </v-tooltip>
                  <v-icon style="transform: rotate(45deg)">clear</v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        style="cursor: pointer"
                        :src="coPurcahses[0].imgUrl"
                        v-on="on"
                        max-width="80"
                        @click="goToProductDetails(coPurcahses[0])"
                      />
                    </template>
                    <span>{{ coPurcahses[0].title }}</span>
                  </v-tooltip>
                  <v-icon style="transform: rotate(90deg)">pause</v-icon>
                </div>
                <div class="d-flex align-center">
                  <b class="pr-2">kr {{ coPurchasePrice1 | currency(2, 2) }}</b>
                  <AddProductsToCartClickAndCollect :prods="coPurchase1" />
                </div>
              </div>
              <v-divider />
              <div
                class="d-flex justify-space-between"
                v-if="coPurcahses.length > 1"
              >
                <div class="d-flex">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img :src="product.imgUrl" v-on="on" max-width="80" />
                    </template>
                    <span>{{ product.title }}</span>
                  </v-tooltip>
                  <v-icon style="transform: rotate(45deg)">clear</v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        style="cursor: pointer"
                        :src="coPurcahses[0].imgUrl"
                        v-on="on"
                        max-width="80"
                        @click="goToProductDetails(coPurcahses[0])"
                      />
                    </template>
                    <span>{{ coPurcahses[0].title }}</span>
                  </v-tooltip>
                  <v-icon style="transform: rotate(45deg)">clear</v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        style="cursor: pointer"
                        :src="coPurcahses[1].imgUrl"
                        v-on="on"
                        max-width="80"
                        @click="goToProductDetails(coPurcahses[1])"
                      />
                    </template>
                    <span>{{ coPurcahses[1].title }}</span>
                  </v-tooltip>
                  <v-icon style="transform: rotate(90deg)">pause</v-icon>
                </div>
                <div class="d-flex align-center">
                  <b class="pr-2">kr {{ coPurchasePrice2 | currency(2, 2) }}</b>
                  <AddProductsToCartClickAndCollect :prods="coPurchase2" />
                </div>
              </div>
              <v-divider v-if="coPurcahses.length > 1" />
            </div>
          </v-col>
        </v-row>
        <v-divider class="mx-2 mt-5" />
        <RecommendationBox
          v-if="product"
          class="mt-6"
          :userId="this.$user.onlineSluttKundeId"
          presentation="grid"
          :itemQty="4"
          :itemType="itemType.P"
          :chainId="parseInt(this.$route.params.chainId)"
          :location="location.PRODUCT_PAGE"
          :channel="channel.Nettbutik"
          :productIds="[this.$route.params.productId]"
          :urlBase="urlBase"
          @cardClick="goToProductDetailsRec"
          @buttonClick="addBtnAction"
          :cartItemsIds="cartItemIds"
        >
        </RecommendationBox>
        <!-- Removed :static="true" -->
        <!--<product-suggestions
          class="mx-5"
          :product="product"
          suggestion-text="Anbefalte produkter"
          suggestions-for="productDetailsPage"
        />-->
      </v-container>
      <v-dialog v-model="galleryPreviewDialog" max-width="800">
        <v-card>
          <video
            id="gallery-video"
            controls=""
            style="display: block; width: 100%; height: auto"
          >
            <source :src="product.videoUrl" type="video/mp4" />
          </video>
        </v-card>
      </v-dialog>

      <v-dialog v-model="productImageDialog" max-width="550">
        <v-card>
          <v-img
            :src="product.imgUrl"
            class="mx-auto"
            lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="
            transition="fade-transition"
          />
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <v-overlay absolute :value="$wait.is('loading webshop getProductsByIds')">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import {
  AddToCartClickAndCollect,
  AddProductsToCartClickAndCollect,
} from "@/components/webshop";
// import ProductSuggestions from "../../../components/webshop/ProductSuggestions";
import visa from "@/assets/payment-methods/logo_visa.png";
import mastercard from "@/assets/payment-methods/logo_mastercard.png";
import klarna from "@/assets/payment-methods/logo_klarna.png";
import vipps from "@/assets/payment-methods/logo_vipps.png";
import apple_pay from "@/assets/payment-methods/logo_apple_pay.png";
import google_pay from "@/assets/payment-methods/logo_google_pay.png";
import { waitFor } from "vue-wait";
import RecommendationBox from "@fixit/v-recommendation-box";
import {
  ItemType,
  Location,
  Channel,
} from "@fixit/v-recommendation-box/src/enums";
import { mapWaitingActions } from "vue-wait";
// import moment from '@/plugins/moment';
export default {
  name: "product-details",
  components: {
    // ProductSuggestions,
    AddToCartClickAndCollect,
    AddProductsToCartClickAndCollect,
    RecommendationBox,
  },
  mixins: [webshopMixins],
  data() {
    return {
      product: null,
      galleryPreviewDialog: false,
      productImageDialog: false,
      coPurcahses: [],
      fetchedCoPurchaseDiscounts: [],
      paymentMethods: [],
      itemType: ItemType,
      location: Location,
      channel: Channel,
    };
  },
  methods: {
    ...mapWaitingActions("favorites", {
      updateFavoriteProducts: "loading favorites updateFavoriteProducts",
    }),

    lowestPriceDate() {
      return this.$moment(this.product.dateOfLowestPrice).format("DD.MM");
    },
    lowestPriceDiscount() {
      return (
        (this.product.lowestPrice / this.product.productDetails.price) * 100
      );
    },
    async addBtnAction(item) {
      var link = item.urlSafe.split("/");
      var product = await this.$store.dispatch("webshop/getProductsByIds", {
        avoidCache: true,
        chainId: parseInt(this.$route.params.chainId),
        includeCampaignProducts: true,
        isBase64: true,
        productIds: [link[1]],
      });
      this.$store.dispatch("webshop/set", {
        key: "addedToCartDialog",
        value: false,
      });
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product[0],
      });
      this.addProductToSalonCart(this.salons[0]);
    },
    getCampaignDiscount(discount) {
      if (discount && discount.OriginalPrice > discount.DiscountPrice) {
        return Math.round(
          ((discount.OriginalPrice - discount.DiscountPrice) /
            discount.OriginalPrice) *
            100
        );
      }
    },
    getBestDiscount(discounts) {
      if (discounts.length) {
        if (discounts.length > 1) {
          let minDiscount = discounts.sort(function (a, b) {
            return parseFloat(a.DiscountPrice) - parseFloat(b.DiscountPrice);
          })[0];

          return minDiscount.DiscountPrice;
        } else {
          return discounts[0].DiscountPrice;
        }
      } else {
        return -1;
      }
    },
    getCategoryName(categoryId) {
      let category = this.mappedCategories.find(
        (x) => x.webshopCategoryId === categoryId
      );
      return category ? category.title : "";
    },
    getMainCatgory(categoryId) {
      return this.mappedCategories.find((x) =>
        x.children.includes(
          this.allChildCategories.find(
            (x) => x.webshopCategoryId === categoryId
          )
        )
      )
        ? this.mappedCategories.find((x) =>
            x.children.includes(
              this.allChildCategories.find(
                (x) => x.webshopCategoryId === categoryId
              )
            )
          )
        : this.mappedCategories.find((x) => x.webshopCategoryId === categoryId);
    },
    getCategoryFirst(categoryId) {
      let category = this.mappedCategories.find((x) =>
        x.children.includes(
          this.allChildCategories.find(
            (x) => x.webshopCategoryId === categoryId
          )
        )
      )
        ? this.mappedCategories.find((x) =>
            x.children.includes(
              this.allChildCategories.find(
                (x) => x.webshopCategoryId === categoryId
              )
            )
          )
        : this.mappedCategories.find((x) => x.webshopCategoryId === categoryId);

      return this.categories.find((x) => x.children.includes(category))
        .urlSafeTitle;
    },
    goToCategory(category) {
      this.$router
        .push({
          name: "webshopChainProductsMainCategories",
          params: { categoryFirst: category },
          query:
            this.getMainCatgory(this.product.categoryId).webshopCategoryId ===
            this.product.categoryId
              ? { category: this.product.categoryId.toString() }
              : {
                  category: this.product.categoryId.toString(),
                  mCategory: this.getMainCatgory(this.product.categoryId)
                    .urlSafeTitle,
                },
        })
        .catch(() => {});
    },
    async addAsFavorite() {
      await this.updateFavoriteProducts({ product: this.product.id });
    },
  },
  computed: {
    isUserFavorite() {
      return (
        this.$store.getters["favorites/getFavoriteProuct"](this.product.id) !=
        null
      );
    },
    salonSorted() {
      return this.salons
        .slice()
        .sort((a, b) =>
          this.getStockAmountForSite(a) < this.getStockAmountForSite(b) ? 1 : -1
        );
    },
    salonsWithStock() {
      return this.salons.filter(
        (salon) => this.getStockAmountForSite(salon) > 0
      );
    },
    noSalonHasHomeShipment() {
      return this.salons.filter((x) => x.homeShipmentEnabled).length === 0;
    },
    coPurchase1() {
      let products = [];
      products.push(this.product);
      products.push(this.coPurcahses[0]);
      return products;
    },
    coPurchase2() {
      let products = [...this.coPurcahses];
      products.push(this.product);
      return products;
    },
    coPurchasePrice1() {
      if (this.coPurcahses.length) {
        var bundlePrice =
          this.getBestDiscount(this.product.discounts) != -1
            ? this.getBestDiscount(this.product.discounts)
            : this.product.productDetails.price;
        var selectedProdPrice = this.fetchedCoPurchaseDiscounts.find(
          (x) => x.ProductId == this.product.id
        )
          ? this.fetchedCoPurchaseDiscounts.find(
              (x) => x.ProductId == this.product.id
            ).DiscountPrice
          : bundlePrice;
        var coPurchasePrice = this.fetchedCoPurchaseDiscounts.find(
          (x) => x.ProductId == this.coPurcahses[0].id
        )
          ? this.fetchedCoPurchaseDiscounts.find(
              (x) => x.ProductId == this.coPurcahses[0].id
            ).DiscountPrice
          : this.coPurcahses[0].productDetails.price;

        return selectedProdPrice + coPurchasePrice;
      } else {
        return 0;
      }
    },
    coPurchasePrice2() {
      if (this.coPurcahses.length) {
        var bundlePrice =
          this.getBestDiscount(this.product.discounts) != -1
            ? this.getBestDiscount(this.product.discounts)
            : this.product.productDetails.price;
        var selectedProdPrice = this.fetchedCoPurchaseDiscounts.find(
          (x) => x.ProductId == this.product.id
        )
          ? this.fetchedCoPurchaseDiscounts.find(
              (x) => x.ProductId == this.product.id
            ).DiscountPrice
          : bundlePrice;
        this.coPurcahses.forEach((x) => {
          var bestPrice = this.fetchedCoPurchaseDiscounts.find(
            (y) => y.ProductId == x.id
          )
            ? this.fetchedCoPurchaseDiscounts.find((y) => y.ProductId == x.id)
                .DiscountPrice
            : x.productDetails.price;
          selectedProdPrice += bestPrice;
        });
        return selectedProdPrice;
      } else {
        return 0;
      }
    },
    outOfStock() {
      return !this.product.productDetails.inventory.length;
    },

    cartProduct() {
      return this.cartItems.find((x) => x.id === this.product.id);
    },
    allChildCategories() {
      let children = [];
      this.mappedCategories.forEach((c) => {
        c.children.forEach((ch) => {
          children.push(ch);
        });
      });
      return children;
    },
    bestPriceNotice() {
      return (
        this.product.productDetails.campaigns.filter(
          (c) => c?.PromotionType == 4
        ).length != 0
      );
    },
    activePaymentMethods() {
      const ua = window.navigator.userAgent;
      const iosDevice = ua.match(/iPad/i) || ua.match(/iPhone/i);
      const isIos =
        iosDevice?.toString() == "iPad" || iosDevice?.toString() == "iPhone";
      const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
      const isMac = /Macintosh/i.test(ua); // Check for macOS

      var methods = [];
      this.$store.getters["webshopCore/get"]("paymentMethods").forEach((x) => {
        if (x.title == "Kort" && x.active) {
          methods.push(visa);
          methods.push(mastercard);
        }
        if (x.title == "Vipps" && x.active) methods.push(vipps);
        if (x.title == "Klarna" && x.active) methods.push(klarna);
        if (x.title == "Apple Pay" && x.active && (isIos || isSafari || isMac))
          methods.push(apple_pay);
        if (x.title == "Google Pay" && x.active) methods.push(google_pay);
      });
      return methods;
    },
  },
  beforeDestroy() {
    this.$store.dispatch("webshop/set", {
      key: "selectedProduct",
      value: null,
    });
  },
  watch: {
    galleryPreviewDialog: {
      handler(val) {
        this.$nextTick(() => {
          let player = document.getElementById("gallery-video");
          if (player) {
            if (val) player.play();
            else player.pause();
          }
        });
      },
    },
    product: {
      handler(val) {
        if (val) {
          waitFor("load webshop coPurchase", async function () {
            this.coPurcahses = await this.$store.dispatch(
              "webshopCore/getCoPurchases",
              {
                productIds: [
                  {
                    productGuid: val.id,
                    productId: val.odinProductId,
                  },
                ],
                count: 2,
                chainId: this.currentChainId,
                applicationNumber: 5,
              }
            );
            if (this.coPurcahses?.length) {
              var productItems = this.coPurcahses.map((x) => {
                return {
                  Id: x.id,
                  Quantity: 1,
                };
              });
              productItems.push({
                Id: this.product.id,
                Quantity: 1,
              });
              await this.$store
                .dispatch("clickAndCollect/fetchDiscounts", {
                  siteId: this.webshopSettings.activatedSalons[0].siteId,
                  productItems: productItems,
                })
                .then((x) => {
                  if (x.length) {
                    this.fetchedCoPurchaseDiscounts = [...x];
                  }
                });
            }
          }).apply(this);
        }
      },
    },
    "$route.params.productId": {
      handler(val) {
        this.product = null;
        waitFor("loading webshop getProductsByIds", async function () {
          let products = await this.$store.dispatch(
            "webshop/getProductsByIds",
            {
              chainId: this.currentChainId,
              productIds: [val],
              isBase64: true,
              avoidCache: true,
              includeCampaignProducts: true,
            }
          );
          products.forEach((p) => {
            if (p.productDetails) {
              let campaign =
                p.productDetails.campaigns.length > 1 && p.discounts.length
                  ? p.productDetails.campaigns.find(
                      (c) => c.CampaignId == p.discounts[0].CampaignId
                    )
                  : p.productDetails.campaigns[0];

              p.bestCampaign = campaign;
              p.salePrice =
                campaign?.PromotionType === 4 ||
                campaign?.PromotionType == 1 ||
                !campaign
                  ? p.productDetails?.price
                  : p.productDetails.discounts[0]?.DiscountPrice;
            }
          });

          this.$store.dispatch("webshop/set", {
            key: "selectedProduct",
            value: products[0],
          });

          if (products.length) this.product = products[0];
        }).apply(this);
      },
      immediate: true,
    },
  },
  async mounted() {
    await this.$store.dispatch("webshopCore/getPaymentMethods");
  },
};
</script>

<style lang="scss" scoped>
.product__details__btn::v-deep {
  .v-btn {
    min-width: unset !important;
  }
}

.v-list--three-line .v-list-item .v-list-item__subtitle,
.v-list-item--three-line .v-list-item__subtitle {
  -webkit-line-clamp: unset;
}

.brands_series__title {
  line-height: 1;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.v-image::v-deep {
  .v-image__image--cover {
    background-size: contain !important;
  }
}

.hover-hand {
  cursor: pointer;
}

.stock_salon__list {
  height: 100%;
  max-height: 115px;
  overflow-y: auto;
}

.price__box::v-deep {
  border-radius: 5px;

  .v-btn {
    padding: 15px !important;
    width: inherit !important;
    border-radius: 5px;
    height: 50px !important;
    //background-color: #7e697f !important;
  }

  .v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    color: black !important;
    //background-color: #7e697f !important;
  }
}

.v-tab--disabled {
  opacity: 1;
}

.v-tab {
  padding: 0;
  text-transform: capitalize;
}
</style>
